import * as React from "react";

import { CoreDetailProps } from "../Detail";

import DeactivateButton from "./DeactivateButton";
import ActivateButton from "./ActivateButton";

export class CoreDetailsButtons extends React.Component<CoreDetailProps> {
    public render() {
        return (
            <>
                {this.props.customerUser.active ? <DeactivateButton /> : <ActivateButton />}
            </>
        );
    }
}
